import {
    type ColorFieldRecentConstantType,
    type ColorFieldAlphaConstantType,
    type ColorFieldParseConstantType,
    type ColorFieldParsedValue
} from "./type";
import {
    parseColorString,
    formatColorHex
} from "../../helpers/color";

export const COLOR_FIELD_RECENT_LIMIT = 8;

export const COLOR_FIELD_EMPTY_COLOR = "#00000000";

export const COLOR_FIELD_SESSION: {
    recents: Array<string>;
} = {
    recents: []
};

const COLOR_FIELD_PLAIN_HEX_PATTERN = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i;

const COLOR_FIELD_UNSETTLED_HEX_PATTERN = /^#?[0-9a-f]{4}$/i;

const COLOR_FIELD_BARE_HEX_PATTERN = /^[0-9a-f]{3,8}$/i;

const COLOR_FIELD_PERCENT_PATTERN = /^\d{1,3}$/;

export const getColorFieldValue = ({
    isAlphaEnabled,
    alpha,
    text
}: ColorFieldParseConstantType): ColorFieldParsedValue | null => {
    const trimmed = text.trim();

    const parsed = parseColorString(COLOR_FIELD_BARE_HEX_PATTERN.test(trimmed) ? `#${trimmed}` : trimmed);

    if(!parsed) {
        return null;
    }

    const nextAlpha = COLOR_FIELD_PLAIN_HEX_PATTERN.test(trimmed) ? alpha : parsed.alpha;

    return {
        alpha: isAlphaEnabled ? nextAlpha : 1,
        hex: formatColorHex({
            alpha: nextAlpha,
            rgb: parsed.rgb,
            isAlphaEnabled
        })
    };
};

export const getIsColorFieldTextUnsettled = (text: string) => {
    return COLOR_FIELD_UNSETTLED_HEX_PATTERN.test(text.trim());
};

export const getColorFieldAlphaPercent = (alpha: number) => {
    return Math.round(alpha * 100);
};

export const getColorFieldAlphaFromText = (text: string): number | null => {
    const trimmed = text.trim();

    if(!COLOR_FIELD_PERCENT_PATTERN.test(trimmed)) {
        return null;
    }

    const percent = Number(trimmed);

    return percent > 100 ? null : percent;
};

export const getColorFieldAlphaHex = ({
    percent,
    hex
}: ColorFieldAlphaConstantType) => {
    const parsed = parseColorString(hex);

    if(!parsed) {
        return hex;
    }

    return formatColorHex({
        alpha: percent / 100,
        isAlphaEnabled: true,
        rgb: parsed.rgb
    });
};

export const getColorFieldRecents = ({
    recents,
    value
}: ColorFieldRecentConstantType) => {
    if(value === "") {
        return recents;
    }

    return [
        value,
        ...recents.filter((item) => item !== value)
    ].slice(0, COLOR_FIELD_RECENT_LIMIT);
};
